export default __webpack_public_path__ + "static/Cebu-Landmasters-Horizontal-White_1-cd443a225a287c587e85f6a67f3a677a.svg";